import { Link } from 'react-router-dom';
import Seo from '@/components/feature/Seo';
import { pageSeo } from '@/mocks/seo';

export default function TermsAndConditions() {
  return (
    <main className="w-full py-12 md:py-16 bg-white">
      <Seo {...pageSeo.terms} />
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-4xl mx-auto">
        <h1 className="text-2xl md:text-3xl font-bold text-navy-900 mb-8">Terms and Conditions</h1>
        <div className="text-sm text-navy-700 leading-relaxed space-y-6">
          <p>
            Welcome to Leavitt Peak Press. By accessing or using our website, you agree to be bound by these Terms and Conditions. Please read them carefully before using our services.
          </p>
          <h2 className="text-lg font-semibold text-navy-900">1. Acceptance of Terms</h2>
          <p>
            By accessing our website, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, please do not use our website.
          </p>
          <h2 className="text-lg font-semibold text-navy-900">2. Services</h2>
          <p>
            Leavitt Peak Press provides publishing and marketing services for authors. The specific services, timelines, and deliverables will be outlined in separate agreements between Leavitt Peak Press and individual authors.
          </p>
          <h2 className="text-lg font-semibold text-navy-900">3. Intellectual Property</h2>
          <p>
            All content on this website, including text, graphics, logos, images, and software, is the property of Leavitt Peak Press or its content suppliers and is protected by international copyright laws. Unauthorized use or reproduction is prohibited.
          </p>
          <h2 className="text-lg font-semibold text-navy-900">4. User Conduct</h2>
          <p>
            You agree to use our website for lawful purposes only. You may not use our website in any way that could damage, disable, overburden, or impair our servers or networks.
          </p>
          <h2 className="text-lg font-semibold text-navy-900">5. Limitation of Liability</h2>
          <p>
            Leavitt Peak Press shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our website or services.
          </p>
          <h2 className="text-lg font-semibold text-navy-900">6. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms and Conditions at any time. Your continued use of our website following any changes constitutes acceptance of the new terms.
          </p>
          <p>
            For any questions regarding these terms, please <Link to="/contact-us" className="text-navy-500 hover:underline">contact us</Link>.
          </p>
        </div>
      </div>
    </main>
  );
}